module.exports = __webpack_public_path__ + "static/media/header-6.02f73705.png";